import React from "react";
import "./Style/Header.css";

export default function Header() {
  return (
    <div className="heading">
      <div className="left-header">We Go</div>
      <div className="right-header">Weather & Time</div>
    </div>
  );
}
